<template>
    <div class="admin-summary">
        <div class="admin-summary-search-area">
            <lgn-input class="admin-summary-search-area-item" placeholder="搜尋" v-model="searchText"
            :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchSites"
            @keyup.enter.native="searchSites"></lgn-input>
        </div>
        <div class="admin-summary-group-area">
            <button type="button" @click="changeMobileView('class')" class="admin-summary-group-area-item" :class="{'is-active': viewStaticArea == 'class'}">
                <div class="admin-summary-group-area-item-img el-icon-pie-chart">
                </div>
                <div class="admin-summary-group-area-item-label">類型</div>
            </button>
            <button type="button" @click="changeMobileView('net')" class="admin-summary-group-area-item" :class="{'is-active': viewStaticArea == 'net'}">
                <div class="admin-summary-group-area-item-img el-icon-link">
                </div>
                <div class="admin-summary-group-area-item-label">連線</div>
            </button>
            <button type="button" @click="changeMobileView('operator')" class="admin-summary-group-area-item" :class="{'is-active': viewStaticArea == 'operator'}">
                <div class="admin-summary-group-area-item-img el-icon-user">
                </div>
                <div class="admin-summary-group-area-item-label">業者</div>
            </button>
            <button type="button" @click="changeMobileView('version')" class="admin-summary-group-area-item" :class="{'is-active': viewStaticArea == 'version'}">
                <div class="admin-summary-group-area-item-img el-icon-aim">
                </div>
                <div class="admin-summary-group-area-item-label">版本</div>
            </button>
        </div>
        <div class="admin-summary-warp twice">
            <div class="admin-summary-warp-content production" :class="{'mobile-show': viewStaticArea == 'class'}">
                <div class="admin-summary-warp-content-title">場站類型</div>
                <svg class="admin-summary-warp-content-draw" v-show="wattingSiteConnection"></svg>
                <div class="admin-summary-warp-content-description" v-show="wattingSiteConnection">
                    <button type="button" class="admin-summary-warp-content-description-item"
                    :class="[`production-${index}`]" v-for="(item, index) in sortByVersionList" :key='index'
                    @click="searchProduction(item[0])">
                        <div class="admin-summary-warp-content-description-item-key">{{item[0]}}</div>
                        <div class="admin-summary-warp-content-description-item-value">{{item[1]}}</div>
                    </button>
                    <div class="admin-summary-warp-content-description-total">
                        <div class="admin-summary-warp-content-description-total-label">總數：</div>
                        <div class="admin-summary-warp-content-description-total-value">{{sortByVersionLength}}</div>
                    </div>
                </div>
                <div class="admin-summary-warp-content-watting" v-show="!wattingSiteConnection">
                    <i class="el-icon-loading"></i>
                </div>
            </div>
            <div class="admin-summary-warp-content connection" :class="{'mobile-show': viewStaticArea == 'net'}">
                <div class="admin-summary-warp-content-title">連線狀態</div>
                <svg class="admin-summary-warp-content-draw" v-show="wattingProduction"></svg>
                <div class="admin-summary-warp-content-description" v-show="wattingProduction">
                    <button class="admin-summary-warp-content-description-item" 
                    :class="[`connection-${index}`]" v-for="(item, index) in siteConnectionList" :key='index'
                    @click="searchNetconnection(item[0])" :disabled="item[0] == '正常'">
                        <div class="admin-summary-warp-content-description-item-key">{{item[0]}}</div>
                        <div class="admin-summary-warp-content-description-item-value">{{item[1]}}</div>
                    </button>
                </div>
                <div class="admin-summary-warp-content-watting" v-show="!wattingProduction">
                    <i class="el-icon-loading"></i>
                </div>
            </div>
        </div>
        <div class="admin-summary-warp">
            <div class="admin-summary-warp-content operator" :class="{'mobile-show': viewStaticArea == 'operator'}">
                <div class="admin-summary-warp-content-title">各業者場站數</div>
                <svg class="admin-summary-warp-content-draw" v-show="wattingOperatorPie"></svg>
                <div class="admin-summary-warp-content-description operator" v-show="wattingOperatorPie">
                    <div class="admin-summary-warp-content-description-warp first">
                        <button type="button" class="admin-summary-warp-content-description-item operator"
                        :class="[`operator-${index}`]" v-for="(item, index) in sortBySiteList.slice(0,5)" :key='index'
                        @click="searchOperator(item[0])">
                            <div class="admin-summary-warp-content-description-item-key">{{item[0]}}</div>
                            <div class="admin-summary-warp-content-description-item-value">{{item[1]}}</div>
                        </button>
                    </div>
                    <div class="admin-summary-warp-content-description-warp others" :class="{'isCollapse': !viewMoreOperator}">
                        <button class="admin-summary-warp-content-description-item operator operator-others"
                        v-for="(item, index) in sortBySiteList.slice(5,sortBySiteList.length)" :key='index'
                        @click="searchOperator(item[0])">
                            <div class="admin-summary-warp-content-description-item-key">{{item[0]}}</div>
                            <div class="admin-summary-warp-content-description-item-value">{{item[1]}}</div>
                        </button>
                    </div>
                    <button type="button" class="admin-summary-warp-content-description-more" @click="viewMoreOperator = !viewMoreOperator">其他業者({{sortBySiteList.slice(5,sortBySiteList.length).length}}) <i :class="[{'el-icon-caret-bottom' : !viewMoreOperator}, {'el-icon-caret-top' : viewMoreOperator}]"></i></button>
                </div>
                <div class="admin-summary-warp-content-watting" v-show="!wattingOperatorPie">
                    <i class="el-icon-loading"></i>
                </div>
            </div>
        </div>
        <div class="admin-summary-warp" >
            <div class="admin-summary-warp-content smartgate" :class="{'mobile-show': viewStaticArea == 'version'}">
                <div class="admin-summary-warp-content-title">Smartgate版本場站數</div>
                <div class="admin-summary-warp-content-draw" v-if="smartgateList">
                    <div class="bar-chart-item" v-for="(item, index) in smartgateList" :key="index">
                        <button type="button" @click="searchVersion(item[0])" class="bar-chart-item-label">{{item[0]}}</button>
                        <div class="bar-chart-item-value">
                            <div class="bar-chart-item-value-bar" :style="{width: `${item[2]}%`}"></div>
                            <div class="bar-chart-item-value-count">{{item[1]}}</div>
                        </div>
                    </div>
                </div>
                <div class="admin-summary-warp-content-description"></div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import d3 from 'd3'
export default {
    name: "adminSummary",
    data(){
        return{
            sortBySiteList: [],
            sortByVersionLength: 0,
            operatorSiteList: [],
            sortByVersionList: [],
            smartgateList: null,
            AllSiteList: null,
            netErrorSiteList: null,
            siteConnectionList: [],
            viewMoreOperator: false,
            wattingSiteConnection: false,
            wattingProduction: false,
            wattingOperatorPie: false,
            viewStaticArea: 'class',
            searchText: ''
        }
    },
    components: {
        lgnInput
    },
    methods: {
        async getSortBySiteList(){
            let res = null;
            res = await api.getAdminAllRegInfo();
            if(!res.error_status){
                this.sortBySiteList = [];
                res.forEach(function(item){
                    if(item.id.indexOf('P') == '0'){
                        this.sortBySiteList.push([item.id, item.count]);
                    }
                    this.sortBySiteList.sort(function(a, b){
                        if(a[1] > b[1]){
                            return -1
                        } else if(a[1] < b[1]){
                            return 1
                        } else {
                            return 0
                        }
                    })
                }.bind(this));
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        async getSortByVersionList(){
            let res = null;
            res = await api.getAdminAllRegInfo('sw');
            if(!res.error_status){
                let smartgateList = ['Smartgate', 0];
                let towerParkerList = ['TowerParker', 0];
                let fetcAgentList = ['FetcAgent', 0];
                let smartSpaceList = ['SmartSpace', 0];
                this.smartgateList = [];
                let maxVersionCount = 0;
                res.forEach(function(item){
                    let productionName = item.id.split(" ")[0];
                    if(productionName == 'Smartgate'){
                        smartgateList[1] += item.count;
                        let itemVersion = `v${item.id.split("v")[1]}`;
                        if(item.count > maxVersionCount){
                            maxVersionCount = item.count;
                        }
                        this.smartgateList.push([itemVersion, item.count]);
                    } else if(productionName == 'TowerParker'){
                        towerParkerList[1] += item.count;
                    } else if(productionName == 'FetcAgent'){
                        fetcAgentList[1] += item.count;
                    } else if(productionName == 'SmartSpace'){
                        smartSpaceList[1] += item.count; 
                    }
                }.bind(this));
                this.sortByVersionLength = smartgateList[1] + towerParkerList[1] + fetcAgentList[1] + smartSpaceList[1];
                this.sortByVersionList = [smartgateList, towerParkerList, fetcAgentList, smartSpaceList];
                this.smartgateList.sort(function(a, b){
                    if(a[0] > b[0]){
                        return 1
                    } else if(a[0] < b[0]){
                        return -1
                    } else 0
                })
                this.smartgateList.forEach(function(smartgate){
                    smartgate.push((smartgate[1] / maxVersionCount) * 100);
                }.bind(this));
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        async getAllSiteList(){
            let res = await api.postAdminRegSearch();
            if(!res.error_status){
                this.AllSiteList = ['正常', res.length];
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        async getNetErrorSiteList(){
            let res = await api.postAdminRegSearch('', "updated");
            if(!res.error_status){
                this.netErrorSiteList = ['中斷', res.length];
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        drawProductionPie(){
            let svgWidth = 160;
            let svgHeight = 160;
            let dataset = this.sortByVersionList;
            let pieColor= [
                d3.rgb(74, 127, 176), d3.rgb(91, 155, 213), d3.rgb(173, 198, 229), d3.rgb(217, 232, 250)
            ]
            let beClearElement = document.querySelector(".admin-summary-warp-content.production .admin-summary-warp-content-draw");
            if(beClearElement){
                let beClearNodes = beClearElement.childNodes;
                for(let i = beClearNodes.length - 1; i >= 0; i--){
                    beClearElement.removeChild(beClearNodes[i]);
                }
            }
            let root = d3.select(".admin-summary-warp-content.production .admin-summary-warp-content-draw");
            let pie = d3.layout.pie().sort(null).value(d => d[1]);
            let pieData = pie(dataset);
            let arc = d3.svg.arc().innerRadius(0).outerRadius(svgWidth/2);
            let arcs = root.selectAll("g").data(pieData).enter().append("g").attr("transform", `translate(${svgWidth / 2}, ${svgHeight / 2})`); 
            arcs.append("path").attr("fill", (d, i) => pieColor[i]).attr("d", d => arc(d));
        },
        drawSiteConnectionPie(){
            let svgWidth = 160;
            let svgHeight = 160;
            this.AllSiteList[1] -= this.netErrorSiteList[1];
            let dataset = [this.AllSiteList, this.netErrorSiteList];
            this.siteConnectionList = dataset;
            let pieColor= [
                d3.rgb(204, 229, 212), d3.rgb(220, 109, 11), d3.rgb(204,213,230)
            ]
            let beClearElement = document.querySelector(".admin-summary-warp-content.connection .admin-summary-warp-content-draw");
            if(beClearElement){
                let beClearNodes = beClearElement.childNodes;
                for(let i = beClearNodes.length - 1; i >= 0; i--){
                    beClearElement.removeChild(beClearNodes[i]);
                }
            }
            let root = d3.select(".admin-summary-warp-content.connection .admin-summary-warp-content-draw");
            let pie = d3.layout.pie().sort(null).value(d => d[1]);
            let pieData = pie(dataset);
            let arc = d3.svg.arc().innerRadius(0).outerRadius(svgWidth/2);
            let arcs = root.selectAll("g").data(pieData).enter().append("g").attr("transform", `translate(${svgWidth / 2}, ${svgHeight / 2})`); 
            arcs.append("path").attr("fill", (d, i) => pieColor[i]).attr("d", d => arc(d));
        },
        drawOperatorPie(){
            let svgWidth = 160;
            let svgHeight = 160;
            let preDataset = JSON.parse(JSON.stringify(this.sortBySiteList));
            let dataset = [];
            preDataset.forEach((item, index) => {
                if(index < 5){
                    dataset[index] = preDataset[index];
                } else {
                    if(!dataset[5]){
                        dataset[5] = ['others', 0]
                    }
                    dataset[5][1] += preDataset[index][1];
                }
            });
            this.operatorSiteList = dataset;
            let pieColor= [
                d3.rgb(141, 167, 217), d3.rgb(167, 207, 139), d3.rgb(243, 221, 90), d3.rgb(251, 189, 0), d3.rgb(201, 151, 0), d3.rgb(199, 199, 199)
            ]
            let beClearElement = document.querySelector(".admin-summary-warp-content.operator .admin-summary-warp-content-draw");
            if(beClearElement){
                let beClearNodes = beClearElement.childNodes;
                for(let i = beClearNodes.length - 1; i >= 0; i--){
                    beClearElement.removeChild(beClearNodes[i]);
                }
            }
            let root = d3.select(".admin-summary-warp-content.operator .admin-summary-warp-content-draw");
            let pie = d3.layout.pie().sort(null).value(d => d[1]);
            let pieData = pie(dataset);
            let arc = d3.svg.arc().innerRadius(0).outerRadius(svgWidth/2);
            let arcs = root.selectAll("g").data(pieData).enter().append("g").attr("transform", `translate(${svgWidth / 2}, ${svgHeight / 2})`);
            arcs.append("path").attr("fill", (d, i) => {
                return pieColor[i]
            }).attr("d", d => arc(d));
        },
        searchSites(){
            if(this.searchText.trim().length == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "請輸入關鍵字!"
                })
                return false;
            }
            this.$router.push({
                name: 'RegList',
                params: {
                    site: this.searchText
                }
            })
        },
        searchProduction(production){
            this.$router.push({
                name: 'RegList',
                params: {
                    site: production
                }
            })
        },
        searchNetconnection(netStatus){
            if(netStatus == '中斷'){
                this.$router.push({
                    name: 'RegList',
                    params: {
                        status: 1,
                        site: ''
                    }
                })
            }
        },
        searchOperator(operator){
            this.$router.push({
                name: 'RegList',
                params: {
                    site: operator
                }
            })
        },
        searchVersion(version){
            this.$router.push({
                name: 'RegList',
                params: {
                    site: version
                }
            })
        },
        changeMobileView(key){
            this.viewStaticArea = key;
        }
    },
    watch: {
    },
    async mounted(){
        this.wattingSiteConnection = false;
        this.wattingProduction = false;
        this.wattingOperatorPie = false;
        await this.getSortBySiteList();
        await this.getSortByVersionList();
        await this.getAllSiteList();
        await this.getNetErrorSiteList();
        if(this.$store.state.userInfo){
            this.drawSiteConnectionPie();
            this.wattingSiteConnection = true;
            this.drawProductionPie();
            this.wattingProduction = true;
            this.drawOperatorPie();
            this.wattingOperatorPie = true;
        }
    }
}
</script>